/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_ModerateInputs */

const en_ui_te_summary_moderate = /** @type {(inputs: Ui_Te_Summary_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate aerobic session with some anaerobic contribution.`)
};

const de_ui_te_summary_moderate = /** @type {(inputs: Ui_Te_Summary_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate aerobe Einheit mit etwas anaerobem Anteil.`)
};

/**
* | output |
* | --- |
* | "Moderate aerobic session with some anaerobic contribution." |
*
* @param {Ui_Te_Summary_ModerateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_moderate = /** @type {((inputs?: Ui_Te_Summary_ModerateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_ModerateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_moderate(inputs)
	return de_ui_te_summary_moderate(inputs)
});